import {DatasetDataInfoResponse} from "../../../../api/model/dataset/DatasetDataInfoResponse";

export const mapArraysByTimestampToSameLength = (arrays?: Array<DatasetDataInfoResponse>, multiAxis?: { x: string, y: string, color: string, size: string }): Array<DatasetDataInfoResponse> | undefined => {
    if (!arrays || !multiAxis) return undefined;

    const validIdentifiers = new Set([multiAxis.x, multiAxis.y, multiAxis.color, multiAxis.size]);

    const objectMap = new Map<string, number>();

    arrays.forEach((ar) => {
        if (validIdentifiers.has(ar.identifier as string)) {
            ar.data.forEach(({ key }) => {
                const tempKey = key.slice(0, key.length - 5) + '.000Z';
                objectMap.set(tempKey, (objectMap.get(tempKey) || 0) + 1);
            });
        }
    });

    const goodValuesArray = new Set(Array.from(objectMap.entries()).filter(([_, count]) => count === arrays.length).map(([key]) => key));

    return arrays.map((ar) => ({
        ...ar,
        data: ar.data.filter(({ key }) => goodValuesArray.has(key.slice(0, key.length - 5) + '.000Z')),
    }));
};